import { connect } from "react-redux";

import * as autogiroActions from "./actions";

import * as ssnActions from "../users/actions";

function mapStateToProps(state) {
  return {
    accounting: state.accounting,
    ssn: state.users.accountInfos,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getSSN: (accountId) => {
      return dispatch(ssnActions.account_info_fetch_ssn(accountId));
    },
    getPendingAutogiro: () => {
      return dispatch(autogiroActions.get_pending_autogiro());
    },
    getCompletedAutogiro: () => {
      return dispatch(autogiroActions.get_completed_autogiro());
    },
    completeAutogiroRequest: (order) => {
      return dispatch(autogiroActions.complete_autogiro(order));
    },
    completeAllPendingAutogiroRequests: () => {
      return dispatch(autogiroActions.complete_all_pending_autogiro());
    },
    colsePendingDialog: () => {
      return dispatch(autogiroActions.close_pending_dialog());
    },
    cancelPayment: (order) => {
      return dispatch(autogiroActions.cancel_payment(order));
    },
    clearAfterActionConfirmMsg: () => {
      return dispatch(autogiroActions.clear_after_action_confirm_msg());
    },
    changeAutogiroTableCompletedFilter: (type, key, value) => {
      return dispatch(
        autogiroActions.change_autogiro_table_completed_filter(key, value),
      );
    },
    changeAutogiroTablePendingFilter: (type, key, value) => {
      return dispatch(
        autogiroActions.change_autogiro_table_pending_filter(key, value),
      );
    },
    changeAutogiroTableCompletedPage: (page) => {
      return dispatch(
        autogiroActions.change_autogiro_table_completed_page(page),
      );
    },
    changeAutogiroTablePendingPage: (page) => {
      return dispatch(autogiroActions.change_autogiro_table_pending_page(page));
    },
  };
}

export const autogiroConnector = connect(mapStateToProps, mapDispatchToProps);
